import React from 'react';
import { OtpWhatsAppButton } from '../../components/ui';
import { fmtDateTime } from '../../utils/helpers';

const STEPS = ['mobile', 'otp', 'password'];

// Mobile (APK / phone browser) Forgot password — full width, big inputs.
export default function ForgotPasswordMobile({ vm }) {
  const {
    step, mobile, setMobile, otp, setOtp, pw, setPw, confirm, setConfirm, show, setShow,
    busy, err, reused, submitMobile, submitOtp, submitPassword, resend, back, toLogin,
  } = vm;
  const errBox = err && <div className="auth-mobile-err">{err}</div>;

  return (
    <div className="auth-mobile">
      <div className="auth-mobile-brand">Forgot password</div>
      <div className="auth-steps" style={{ marginTop: 10 }}>
        {STEPS.map((s, i) => <span key={s} className={i <= STEPS.indexOf(step) ? 'on' : ''} />)}
      </div>

      {step === 'mobile' && (
        <form onSubmit={submitMobile} className="auth-mobile-form">
          <div className="muted auth-mobile-sub">Enter your registered mobile number. We will send a code to its WhatsApp.</div>
          <label className="field">Mobile Number
            <input type="tel" inputMode="numeric" autoComplete="tel-national" name="mobile" value={mobile} placeholder="10-digit mobile" autoFocus
              onChange={(e) => setMobile(e.target.value)} />
          </label>
          {errBox}
          <button className="btn primary auth-mobile-btn" disabled={busy}>
            {busy ? 'Sending OTP…' : 'Send OTP on WhatsApp'}
          </button>
        </form>
      )}

      {step === 'otp' && (
        <form onSubmit={submitOtp} className="auth-mobile-form">
          <div className="muted auth-mobile-sub">
            {reused
              ? `Use the OTP already sent to WhatsApp ${mobile} at ${fmtDateTime(reused)}. It is valid for 1 hour, so no new code was sent.`
              : `OTP sent to WhatsApp ${mobile} (valid for 1 hour).`}
          </div>
          <label className="field">4-digit OTP
            <input type="tel" inputMode="numeric" maxLength={4} value={otp} autoComplete="one-time-code" className="auth-mobile-otp" autoFocus
              onChange={(e) => setOtp(e.target.value)} />
          </label>
          <OtpWhatsAppButton />
          {errBox}
          <button className="btn primary auth-mobile-btn" disabled={busy}>
            {busy ? 'Verifying…' : 'Verify OTP'}
          </button>
        </form>
      )}

      {step === 'password' && (
        <form onSubmit={submitPassword} className="auth-mobile-form">
          <div className="muted auth-mobile-sub">OTP verified. Choose a new password for {mobile}.</div>
          <label className="field">New Password
            <input type={show ? 'text' : 'password'} autoComplete="new-password" value={pw} placeholder="4 to 20 characters" autoFocus
              onChange={(e) => setPw(e.target.value)} />
          </label>
          <label className="field">Confirm Password
            <input type={show ? 'text' : 'password'} autoComplete="new-password" value={confirm} placeholder="Re-enter password"
              onChange={(e) => setConfirm(e.target.value)} />
          </label>
          <label className="auth-mobile-check">
            <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} />
            Show password
          </label>
          {errBox}
          <button className="btn primary auth-mobile-btn" disabled={busy}>
            {busy ? 'Saving…' : 'Save & Sign In'}
          </button>
        </form>
      )}

      <div className="auth-mobile-links">
        {step === 'otp' && <button type="button" className="linklike" onClick={resend} disabled={busy}>Resend OTP</button>}
        {step !== 'mobile' && <button type="button" className="linklike" onClick={back}>Back</button>}
        <button type="button" className="linklike" onClick={toLogin}>Back to Sign In</button>
      </div>
    </div>
  );
}
